export enum StyleEnum {
    GREEN = 'bg-green hover:bg-green-dark',
    RED = 'bg-red hover:bg-red-dark'
}
